import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const OngoingOrdersRBAC = {
  pageID: '5dd949ee852e4eae244f2137ebef8e53',
  elementID: {
    ViewPage: 'c9913418a4458e5b5f3505af7fa8dfb5',
    AssignDriver: 'e60ea4b9ed1b265a786d4afcb8ea19d2',
    AssignPacker: '031c84812f1b265a786d1346f3330276',
    AssignPicker: '02e44cf0af1b265a786d133600e9de9e',
    viewPackingDetail: '512fdfce4f72bb7607439c9ca0b596af',
    PrintResi: 'a0b575cd97962a4defbe97b5762dfcbb',
    PrintList: 'a0b57eecc1962a4defbe97b579ed9264',
    PoolOrders: '9010d0a9bbc60d764fdb07e107101c72',
    ChangePicker: 'ac1782532340ec7738f4bf13c3159db7',
    bypassScanResi: '99e7274a5acaeea77192860929785499',
  },
} as const

export const useOngoingOrdersRBACPage = createUseRBAC(OngoingOrdersRBAC.elementID)

export type UseOngoingOrdersRBACType = ReturnType<typeof useOngoingOrdersRBACPage>
